module.exports = __webpack_public_path__ + "f68063ada35c21a127b8030eeb4043cf.png";